module.exports = __webpack_public_path__ + "img/2.7386ee88.webp";